'use client';

import React, { FC } from 'react';
import { Link } from '@/navigation';
import { TypeGlobalNavFields } from '@/core/generated-types';
import { slugBuilder } from '@/core/contentfulConfig';
import { CONTENT_TYPE_LINK } from '@/core/constants';
import AccessibilityLink from '@/components/common/AccessibilityLink/AccessibilityLink';

export interface MessageBannerProps {
  bannerMessage: TypeGlobalNavFields['bannerMessage'];
  bannerLinks: TypeGlobalNavFields['bannerLinks'];
  enableAccessibilityLabel: TypeGlobalNavFields['enableAccessibilityLabel'];
  disableAccessibilityLabel: TypeGlobalNavFields['disableAccessibilityLabel'];
  showAccessibilityLink: TypeGlobalNavFields['showAccessibilityLink'];
}

export const MessageBanner: FC<MessageBannerProps> = ({
  bannerMessage,
  bannerLinks,
  enableAccessibilityLabel,
  disableAccessibilityLabel,
  showAccessibilityLink,
}) => {
  return (
    <div className="bg-blue-deep text-white h-[53px]">
      <div className="flex max-w-[1200px] mx-auto px-4 justify-between items-center h-full">
        <div className="text-sm pr-4">{bannerMessage}</div>
        <div className="flex items-center gap-4">
          {bannerLinks && (
            <div className="flex items-center gap-4 hidden md:flex">
              {bannerLinks.map((link) => {
                const isExternalLink =
                  link.sys.contentType.sys.id === CONTENT_TYPE_LINK.EXTERNAL;
                const href = isExternalLink
                  ? (link.fields as any).linkUrl || '#'
                  : slugBuilder(link as any);

                return (
                  <Link
                    key={link.sys.id}
                    href={href}
                    className="text-sm hover:underline transition-all duration-200"
                  >
                    {(link.fields as any).linkText || 'Link'}
                  </Link>
                );
              })}
            </div>
          )}
          {showAccessibilityLink &&
            enableAccessibilityLabel &&
            disableAccessibilityLabel && (
              <AccessibilityLink
                enableAccessibilityLabel={enableAccessibilityLabel}
                disableAccessibilityLabel={disableAccessibilityLabel}
                className="text-sm hover:underline transition-all duration-200 text-right md:text-left"
              />
            )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(MessageBanner);
